import React from 'react';
import { motion } from 'framer-motion';

interface PageSectionProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  dark?: boolean;
}

const PageSection: React.FC<PageSectionProps> = ({
  title,
  subtitle,
  children,
  className = '',
  dark = false,
}) => {
  return (
    <section
      className={`py-20 ${
        dark ? 'bg-gray-900 text-white' : 'bg-white'
      } ${className}`}
    >
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${
            dark ? 'text-white' : 'text-gray-900'
          }`}>
            {title}
          </h2>
          {subtitle && (
            <p className={`text-lg ${
              dark ? 'text-gray-300' : 'text-gray-600'
            } max-w-2xl mx-auto`}>
              {subtitle}
            </p>
          )}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {children}
        </motion.div>
      </div>
    </section>
  );
};

export default PageSection; 